module.exports = __webpack_public_path__ + "assets/img/lace_selected.06d642c6.svg";